import isMatch from 'date-fns/isMatch';
import { Formik, FormikProps } from 'formik';
import React, { useRef } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import * as Yup from 'yup';
import ContentView from '../../components/ContentView';
import Form from '../../components/form/Form';
import FormButton from '../../components/form/FormButton';
import Spacer from '../../components/Spacer';
import SurveyFormDateInput from '../../components/survey/SurveyFormDateInput';
import Colors from '../../constants/Colors';
import { log } from '../../tools/LogHelper';
import { stringify } from 'flatted';

const StyledContainer = styled.ScrollView<{ isDesktop: boolean }>`
  padding: ${p =>
    p.isDesktop
      ? '100px 15px 100px 15px'
      : Platform.OS === 'web'
      ? '100px 15px 100px 15px'
      : '20px 15px 100px 15px'};
  height: 100%;
  width: 100%;
  background-color: ${Colors.primaryPurple};
`;

const StyledView = styled.KeyboardAvoidingView`
  flex: 1;
`;

const StyledContentView = styled(ContentView)`
  max-width: 500px;
  height: 100%;
  align-self: center;
`;

const SurveyFromDateInputExampleScreen: React.FC = () => {
  const window = useWindowDimensions();
  const isDesktop = window.width >= 768;
  const formikRef = useRef<FormikProps<any> | null>();
  return (
    <StyledView
      keyboardVerticalOffset={97}
      behavior={Platform.select({ ios: 'padding' })}
    >
      <StyledContainer
        isDesktop={isDesktop}
        scrollIndicatorInsets={{ right: 1 }}
      >
        <StyledContentView>
          <Formik
            validateOnMount
            innerRef={formik => (formikRef.current = formik)}
            initialValues={{}}
            validationSchema={Yup.object().shape({
              birthDate: Yup.string()
                .required('Birth date must not be empty.')
                .test('birthDate', 'Invalid Date', function (value) {
                  return isMatch(value as string, 'MM/dd/yyyy');
                })
            })}
            onSubmit={formValues => {
              formikRef.current?.setSubmitting(false);
              log('onSubmit', stringify(formValues));
            }}
          >
            <Form>
              <SurveyFormDateInput
                name='birthDate'
                title='How old are you?'
                description='Most studies have age paramaters for recruitment. Your age helps us find studies that match your profile.'
                label='Enter your birthday'
              />
              <Spacer />
              <FormButton outlined inverse>
                Submit
              </FormButton>
            </Form>
          </Formik>
        </StyledContentView>
      </StyledContainer>
    </StyledView>
  );
};

export default SurveyFromDateInputExampleScreen;
